module.exports = "<div>\r\n  <button mat-icon-button\r\n          mat-button-sm color=\"danger\"\r\n          class=\"mr-1\"\r\n          matTooltip=\"{{ 'CLOSE' | translate }}\"\r\n          (click)=\"onClose()\">\r\n    <mat-icon>close</mat-icon>\r\n  </button>\r\n  &nbsp;\r\n  {{snackMessage.message | translate}}\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/shared/snack-messages/snack-message/snack-message.component.html
// module id = ../../../../../src/app/shared/snack-messages/snack-message/snack-message.component.html
// module chunks = main